module.exports = __webpack_public_path__ + "img/selected3-min.6a0f36b0.png";